"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgStatusLightBulb = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ height: 26, width: 19, xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("g", __assign({ fill: "#fff" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M3.235 16.117a3.76 3.76 0 0 1 1.268 2.164H8.38v-5.429a3.052 3.052 0 0 1-2.285-2.95h1.523c0 .84.684 1.523 1.524 1.523s1.523-.683 1.523-1.523h1.524a3.052 3.052 0 0 1-2.285 2.95v5.429h3.877a3.806 3.806 0 0 1 1.28-2.175 9.13 9.13 0 0 0 3.222-6.966c0-8.194-9.993-12.218-15.684-6.372a9.128 9.128 0 0 0 .637 13.35zM9.14 26a3.05 3.05 0 0 0 3.048-3.047H6.094A3.05 3.05 0 0 0 9.14 26zM4.57 19.804h9.141v1.626h-9.14z" }) })) }))); };
exports.default = SvgStatusLightBulb;
